import React from "react";


function Contact() {
  return (
    <div>
      <div className="row banner" style={{ backgroundImage: 'url(./images/slider-1.png)', backgroundSize: 'cover',  backgroundPosition: 'center',backgroundSize:'cover' }}></div>
      <div className="container" style={{ marginTop: '100px', marginBottom: '100px' }}>

        <div className="row">
          <div className="col-md-5" style={{ background: '#ffffffff', padding: '50px' }}>
            <div className="row" style={{ borderBottom: '0px solid orange', paddingBottom: '15px', paddingTop: '15px' }}>
              <h3 className="cheading" >Address</h3>
              {/* first */}
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-map-marker contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr">
                    Kodimoottil Devi Temple <br />
                    Parippalli P.O, Kollam <br />
                    Kerala - 691574</p>
                </div>
              </div>
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-phone-square contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr">0474 2962400</p>
                </div>
              </div>
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-envelope contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr">kodimoottildevitemple@gmail.com</p>
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-7" style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}>
            {/* <p style={{fontFamily:'anek malayalam',fontSize:'12pt',fontWeight:'700',lineHeight:'20pt'}}>
              പെരളശ്ശേരി ശ്രീ സുബ്രഹ്മണ്യസ്വാമി ക്ഷേത്രത്തിൽ നിന്നും അഞ്ചു കിലോമീറ്റർ ദൂരം
            </p> */}
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5137.267545338754!2d76.75892151378991!3d8.814460285732192!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b05e65c27254eed%3A0x8e48f36519023901!2sKodimoottil%20Sri%20Bhadrakaali%20Kshethra%20yogam%20Trust!5e0!3m2!1sen!2sin!4v1770278297844!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>


          </div>
        </div>


      </div>
    </div>
  );
}

export default Contact;

